import React from 'react';
import { Card, CardContent, CardActions, Typography } from '@mui/material';

/**
 * Card template: title, content, optional actions. Modern look with theme.
 */
export function CardLayout({
  title,
  titleVariant = 'h3',
  subtitle,
  children,
  actions,
  ...cardProps
}) {
  return (
    <Card
      variant="outlined"
      sx={{
        border: 'none',
        overflow: 'hidden',
        ...cardProps.sx,
      }}
      {...cardProps}
    >
      <CardContent sx={{ p: { xs: 2.5, md: 3 } }}>
        {title && (
          <Typography variant={titleVariant} color="primary" gutterBottom sx={{ fontWeight: 700 }}>
            {title}
          </Typography>
        )}
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {subtitle}
          </Typography>
        )}
        {children}
      </CardContent>
      {actions && <CardActions sx={{ px: 2.5, pb: 2 }}>{actions}</CardActions>}
    </Card>
  );
}

export default CardLayout;
